import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import axiosInstance from "../config/axios";
import { MyMenuURL, ViewDishURL } from "../config/config";
import DishDetailsContent from "../dashboard/DishDetailsContent";

const DishDetailModal = ({ open, dishId, onClose }) => {
  const [dishDetails, setDishDetails] = useState(null);
  const [dishesSold, setDishesSold] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchDish = async () => {
      if (!dishId || !open) {
        setDishDetails(null);
        setDishesSold(0);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const [dishResult, menuResult] = await Promise.allSettled([
          axiosInstance().post(ViewDishURL, { id: dishId }),
          axiosInstance().post(MyMenuURL, {}),
        ]);

        if (dishResult.status === "rejected") {
          throw dishResult.reason;
        }

        if (isMounted) {
          const details = dishResult.value?.data?.data || null;
          const menuCategories =
            menuResult.status === "fulfilled"
              ? menuResult.value?.data?.data
              : [];
          const allDishes = Array.isArray(menuCategories)
            ? menuCategories.flatMap((category) =>
                Array.isArray(category?.dishes) ? category.dishes : []
              )
            : [];
          const matchingDish = allDishes.find(
            (dish) => String(dish?._id) === String(dishId)
          );

          setDishDetails(details);
          setDishesSold(
            matchingDish?.formattedTotalSoldCount ??
              details?.formattedTotalSoldCount ??
              details?.totalSoldCount ??
              0
          );
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err?.response?.data?.message || "Failed to load dish details.");
          setLoading(false);
        }
      }
    };

    fetchDish();

    return () => {
      isMounted = false;
    };
  }, [dishId, open]);

  return (
    <Dialog
      open={Boolean(open)}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: "dish-details-modal-paper",
        style: {
          borderRadius: "12px",
          padding: "18px 24px 24px",
        },
      }}
    >
      <div className="dish-details-modal-heading">
        <button type="button" onClick={onClose} aria-label="Close">
          <i className="ri-close-circle-line"></i>
        </button>
      </div>

      {loading && (
        <div className="text-center py-4">
          <div className="spinner-border" role="status" style={{ color: "#8d126e" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {error && !loading && (
        <div className="alert alert-danger my-3 py-2" role="alert">
          {error}
        </div>
      )}

      {!loading && !error && dishDetails && (
        <DishDetailsContent
          dishDetails={dishDetails}
          dishesSold={dishesSold}
        />
      )}
    </Dialog>
  );
};

export default DishDetailModal;
